import * as React from "react";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import TextMask from "../../../Component/TextMask";
import { Cari, Insert } from "../../../Component/api";

export default function RefKodeKegiatanTambah(e) {
  const [valid, setValid] = React.useState(false);
  const [data, setData] = React.useState({
    kode: null,
    nama: null,
    helperKode: null,
    helperNama: null,
  });

  const [tipe, setTipe] = React.useState(null);

  React.useEffect(() => {
    e.data.tipe === "" && setTipe("Urusan");
    e.data.tipe === "urusan" && setTipe("Program");
    e.data.tipe === "program" && setTipe("Kegiatan");
    e.data.tipe === "kegiatan" && setTipe("Sub Kegiatan");
  }, []);

  function cari(v) {
    setData({ ...data, helperKode: null });
    setValid(false);

    let tabel;
    let len;
    let kd;

    switch (tipe) {
      case "Urusan":
        tabel = "refurusan";
        len = 4;
        kd = v;
        break;
      case "Program":
        tabel = "refprogram";
        len = 2;
        kd = e.data.kode + "." + v;
        break;
      case "Kegiatan":
        tabel = "refkegiatan";
        len = 4;
        kd = e.data.kode + "." + v;
        break;
      case "Sub Kegiatan":
        tabel = "refsubkegiatan";
        len = 2;
        kd = e.data.kode + "." + v;

        break;
    }

    if (v.length === len) {
      setData({ ...data, helperKode: "Loading" });
      Cari(tabel, "kode", kd).then((res) => {
        setData({ ...data, kode: kd, helperKode: null });
        setValid(true);
        if (res.data.length > 0) {
          setData({ ...data, helperKode: "Kode ini sudah digunakan" });
          setValid(false);
        }
      });
    }
  }

  function kembali() {
    e.refresh();
    e.setActivePage("tabel");
  }

  function handleProses() {
    if (data.nama === null || data.nama === "") {
      setData({ ...data, helperNama: "Data belum lengkap / masih kosong" });
    } else {
      setData({ ...data, helperNama: null });
      tipe === "Urusan" &&
        Insert("refurusan", data).then(() => {
          kembali();
        });
      tipe === "Program" &&
        Insert("refprogram", data).then(() => {
          kembali();
        });
      tipe === "Kegiatan" &&
        Insert("refkegiatan", data).then(() => {
          kembali();
        });
      tipe === "Sub Kegiatan" &&
        Insert("refsubkegiatan", data).then(() => {
          kembali();
        });
    }
  }

  return (
    <>
      <Card sx={{ background: "#ffffffaa", m: "20px" }}>
        <CardHeader
          title={
            <>
              <Box display="flex">
                <>Tambah {tipe}</>
                <Box flexGrow={1} />
                <IconButton onClick={() => e.setActivePage("tabel")}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </>
          }
        />
        <Divider />
        <CardContent>
          <Stack gap="20px">
            <>
              <strong>
                {e.data.kode} {e.data.uraian}
              </strong>
            </>
            <TextMask
              sx={{ maxWidth: "150px" }}
              name="kode"
              label="Kode"
              variant="standard"
              mask={tipe === "Kegiatan" || tipe === "Urusan" ? "0.00" : "00"}
              startAdornment={tipe === "Urusan" ? "" : `${e.data.kode}.`}
              value={data.kode}
              getValue={(v) => cari(v)}
              helperText={data.helperKode}
            />
            {valid && (
              <>
                <TextField
                  fullWidth
                  size="small"
                  variant="standard"
                  onChange={(v) =>
                    setData({ ...data, nama: v.currentTarget.value })
                  }
                  label={<>Nama {tipe}</>}
                  helperText={data.helperNama}
                ></TextField>
                <Button
                  sx={{ maxWidth: "150px" }}
                  variant="contained"
                  onClick={() => handleProses()}
                >
                  Tambah
                </Button>
              </>
            )}
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
